(() => {
  const initializeGallery = (gallery) => {
    if (!gallery || gallery.dataset.ffsGalleryReady === 'true') return;

    const mainImage = gallery.querySelector('[data-ffs-gallery-main]');
    const stage = gallery.querySelector('[data-ffs-gallery-stage]');
    const thumbnails = [...gallery.querySelectorAll('[data-ffs-gallery-thumb]')];
    const previous = gallery.querySelector('[data-ffs-gallery-previous]');
    const next = gallery.querySelector('[data-ffs-gallery-next]');
    const status = gallery.querySelector('[data-ffs-gallery-status]');
    const zoomTrigger = gallery.querySelector('[data-ffs-gallery-zoom-trigger]');
    const lightbox = gallery.querySelector('[data-ffs-gallery-lightbox]');
    const lightboxImage = gallery.querySelector('[data-ffs-gallery-lightbox-image]');
    const lightboxClose = gallery.querySelector('[data-ffs-gallery-lightbox-close]');
    const lightboxPrevious = gallery.querySelector('[data-ffs-gallery-lightbox-previous]');
    const lightboxNext = gallery.querySelector('[data-ffs-gallery-lightbox-next]');
    let activeIndex = 0;
    let touchStartX = null;
    let suppressZoom = false;
    let lockedScrollY = 0;

    if (!mainImage || thumbnails.length === 0) return;
    gallery.dataset.ffsGalleryReady = 'true';

    const setActivePhoto = (index, options = {}) => {
      activeIndex = (index + thumbnails.length) % thumbnails.length;
      const thumbnail = thumbnails[activeIndex];
      mainImage.src = thumbnail.dataset.src;
      mainImage.alt = thumbnail.dataset.alt;
      zoomTrigger?.setAttribute('aria-label', `Zoom ${thumbnail.dataset.alt}`);

      thumbnails.forEach((item, itemIndex) => {
        const isActive = itemIndex === activeIndex;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (status) status.textContent = `Photo ${activeIndex + 1} of ${thumbnails.length}`;
      if (options.scrollThumbnail !== false) {
        thumbnail.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      if (lightbox?.open && lightboxImage) {
        lightboxImage.src = thumbnail.dataset.src;
        lightboxImage.alt = thumbnail.dataset.alt;
      }
    };

    const move = (direction) => setActivePhoto(activeIndex + direction);

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => setActivePhoto(index));
    });
    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));

    stage?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        move(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        move(1);
      }
    });

    stage?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
      suppressZoom = false;
    }, { passive: true });
    stage?.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
      touchStartX = null;
      if (Math.abs(distance) < 48) return;
      suppressZoom = true;
      move(distance > 0 ? -1 : 1);
      window.setTimeout(() => { suppressZoom = false; }, 0);
    }, { passive: true });

    const openLightbox = () => {
      if (suppressZoom || !lightbox || !lightboxImage) return;
      const thumbnail = thumbnails[activeIndex];
      lightboxImage.src = thumbnail.dataset.src;
      lightboxImage.alt = thumbnail.dataset.alt;
      lockedScrollY = window.scrollY;
      document.body.style.top = `-${lockedScrollY}px`;
      document.body.classList.add('ffs-lightbox-open');
      if (typeof lightbox.showModal === 'function') lightbox.showModal();
      else lightbox.setAttribute('open', '');
      lightboxClose?.focus();
    };

    const unlockPage = () => {
      if (!document.body.classList.contains('ffs-lightbox-open')) return;
      document.body.classList.remove('ffs-lightbox-open');
      document.body.style.removeProperty('top');
      window.scrollTo(0, lockedScrollY);
    };

    const closeLightbox = () => {
      if (!lightbox) return;
      if (typeof lightbox.close === 'function') lightbox.close();
      else {
        lightbox.removeAttribute('open');
        unlockPage();
      }
      zoomTrigger?.focus();
    };

    zoomTrigger?.addEventListener('click', openLightbox);
    lightboxClose?.addEventListener('click', closeLightbox);
    lightboxImage?.addEventListener('click', closeLightbox);
    lightboxPrevious?.addEventListener('click', () => move(-1));
    lightboxNext?.addEventListener('click', () => move(1));
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) closeLightbox();
    });
    lightbox?.addEventListener('close', unlockPage);
    lightbox?.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeLightbox();
    });
    lightbox?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        move(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        move(1);
      }
    });

    setActivePhoto(0, { scrollThumbnail: false });
  };

  const initializeAllGalleries = (root = document) => {
    root.querySelectorAll('[data-ffs-product-gallery]').forEach(initializeGallery);
  };

  initializeAllGalleries();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const productInfo = document.querySelector(`product-info[data-section="${data.sectionId}"]`);
      const currentGallery = productInfo?.querySelector('[data-ffs-product-gallery]');
      const updatedGallery = data.html.querySelector('[data-ffs-product-gallery]');
      if (currentGallery && updatedGallery) {
        const replacement = updatedGallery.cloneNode(true);
        currentGallery.replaceWith(replacement);
        initializeGallery(replacement);
      }

      const currentTitle = productInfo?.querySelector('.product__title h1');
      const updatedTitle = data.html.querySelector('.product__title h1');
      if (currentTitle && updatedTitle) currentTitle.textContent = updatedTitle.textContent;
    });
  }
})();
